import { Translate } from '@chipinside/translate'
import { Alert } from '@mui/material'
import { isEmpty } from 'lodash'

type MessageObject = {
  message?: string
  [key: string]: any
}

function collectMessages(obj: MessageObject | MessageObject[]): string[] {
  const messages: string[] = []

  function recurse(value: any): void {
    if (Array.isArray(value)) {
      value.forEach(recurse)
    } else if (value && typeof value === 'object') {
      if (typeof value.message === 'string') {
        messages.push(value.message)
      }
      for (const key in value) {
        recurse(value[key])
      }
    }
  }

  recurse(obj)
  return Array.from(new Set(messages))
}

const TextError = ({ errors }: any) => {
  if (isEmpty(errors)) return null

  const messages = collectMessages(errors)
  if (messages.length === 0) return null

  return (
    <Alert severity="error">
      {Translate({ messageKey: 'form_with_errors' })}
      <ul>
        {messages.map((msg, idx) => (
          <li key={idx}>{msg}</li>
        ))}
      </ul>
    </Alert>
  )
}

export { TextError }

const FormbuilderListErrors = ({ errors }: { errors: Array<string> }) => {
  if (isEmpty(errors)) return null

  return (
    <Alert severity="error">
      {Translate({ messageKey: 'form_with_errors' })}
      <ul>
        {errors?.map((msg, idx) => (
          <li key={idx}>{msg}</li>
        ))}
      </ul>
    </Alert>
  )
}

export { FormbuilderListErrors }
